import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const GROUP_PARAM = "group";
const PAGE_PARAM = "page";

type SetGroupOptions = {
  resetPage?: boolean;
};

/**
 * Reads and writes the selected participant group filter in the URL query string.
 */
export function useListGroupParam(): [
  string,
  (group: string, options?: SetGroupOptions) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();
  const group = searchParams.get(GROUP_PARAM) ?? "";

  const setGroup = useCallback(
    (value: string, options?: SetGroupOptions) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (value.trim() === "") {
            next.delete(GROUP_PARAM);
          } else {
            next.set(GROUP_PARAM, value);
          }
          if (options?.resetPage) {
            next.delete(PAGE_PARAM);
          }
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return [group, setGroup];
}
